GP.views.ChatUserItem = Backbone.Marionette.ItemView.extend({
    template: function(serialized_data) {
        return template('chat-user', serialized_data);
    },
    className: 'chat-user online',
    events: {
        'click .chat-kick-user':'kick_user',
    },
    kick_user: function(evnt) {
        evnt.stopPropagation();

        if (confirm('Kick this user from the livestream?')) {
            $.ajax({
                url: '/members/videochat/kick',
                type: 'POST',
                data: {
                    'kick_duid': this.model.get('duid')
                },
                success: function(data) {
                    if (data.status) {
                        alert('User has been kicked');
                    }
                }
            });
        }
    },
    templateHelpers: {
        user_online: function() {
            return (this.chat_user && this.chat_user.online) ? '' : 'hide';
        },
        user_online_class: function() {
            return (this.chat_user && this.chat_user.online) ? 'friend-user-online' : '';
        }
    },
    initialize:function(opts) {
        // re-render itemview on model change
        this.listenTo(this.model, 'change', this.render);
        this.event_ns = opts.event_ns;
    },
    onRender: function() {
        var classname = this.model.get('gender').toLowerCase();
        this.$el.removeClass().addClass(this.className + ' ' + classname);

        if (this.model.get('thumb_url')) {
            this.$el.find('img.thumb').addClass('lazy');
//        } else {
//           this.$el.find('img.thumb').remove();
        }
        if (this.model.get('profile_new_window')) {
            this.$el.find('a.chat-profile-link').attr('target', '_blank');
        }

        this.$el.find('.chat-kick-user').attr('title', 'Kick User');
        this.$el.find('.chat-profile-report-user').attr('title', 'Report User');
    },
    // return data to pass to handlebar template
    serializeData: function() {
        var tdata = {
            chat_user: this.model.toJSON()
        };
        return tdata;
    }
});

GP.views.ChatUserList = Backbone.Marionette.CollectionView.extend({
    childView: GP.views.ChatUserItem
});
